export function checkImageFormat(url: string) {
  return (
    url.includes("jpg") ||
    url.includes("JPG") ||
    url.includes("png") ||
    url.includes("PNG") ||
    url.includes("jpeg") ||
    url.includes("JPEG")
  );
}

export function checkVideoFormat(url: string) {
  return url.includes("mp4") || url.includes("webm") || url.includes("MOV");
}
